import React, { useEffect, useState, useContext, useRef } from 'react';
import './machine_css.css';
import completed_grey from '../Icons/completed_grey.png';
import completed_green from '../Icons/completed_green.png';
import completed_error from '../Icons/dispense-error.svg';
import { pageVariants, pageTransition } from '../items/style/animationstyle';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import { UserContext } from '../contexts/userContext';
import request from '../services/Request';
import localRequest from '../services/LocalServer/localRequest';
import EnterEmail from './enterEmail';
import IdleEmail from '../machineUI/items/IldeEmail';
import MscCart from './company/MSC/mscCart';
import logger from '../services/LocalServer/logger';
import Cookies from 'js-cookie';

const oneTimeStatus = '/promos/status';
const createOrderURL = `/orders/create`;

export default function ProductDispense(props) {
  const { testMode } = useContext(UserContext);
  const isLocal = localStorage.getItem('ISLOCAL') === 'TRUE';
  const { stat, setStat, linkPromo } = props;
  const machine = JSON.parse(localStorage.getItem('machine'));
  const msc = localStorage.getItem('MSC') === 'TRUE';
  const currency = machine?.currency?.code;

  const { receipt, belongTo, name } = machine;

  let p = JSON.parse(localStorage.getItem('SeparateItem'));
  p = p.filter((e) => e.prodType === 'prod');

  const { t } = useTranslation();
  const machineID = props.id;
  console.log('machineID', machineID);
  const [separateItem, setP] = useState(p);
  const [pod, setPods] = useState([...p, { item_id: 0 }]);
  const [failOne, setFailOne] = useState(false);
  const [readySend, setReadySend] = useState(false);
  const [door, setDoor] = useState(t('Your items are vending, please wait.'));
  const [receiptSend, setReceiptSend] = useState(false);
  let [FinalTax, setFinalTax] = useState(parseFloat(localStorage.getItem('FinalTax')));
  let [TotalPrice, setTotalPrice] = useState(parseFloat(localStorage.getItem('TotalPrice')));
  const [orderID, setOrderID] = useState('');
  const [show, setShow] = useState(false);
  const [go, setGo] = useState(false);
  const [credit, setCredit] = useState(0);
  const countRef = useRef(0);
  const [input, setInput] = useState('');

  let history = useHistory();

  useEffect(() => {
    var interval = setInterval(() => fetchAPI(), 1000);
    return () => {
      clearInterval(interval);
    };

    async function fetchAPI() {
      try {
        await localRequest({
          method: 'get',
          url: `${process.env.REACT_APP_LOCAL_API}/dispenseStatus/${pod[countRef.current].item_id}`,
        }).then(async (status) => {
          if (status.data.status === 'SUCCESS') {
            const index = pod.findIndex((e) => e.item_id === status.data.item_id);
            if (index > -1 && pod[index].status !== 'SUCCESS') {
              pod[index].status = 'SUCCESS';
              setPods([...pod]);
              countRef.current = countRef.current + 1;
              setDoor(t('Your items are vending, please wait.'));
            }
          } else if (status.data.status === 'FAIL') {
            setFailOne(true);
            const index = pod.findIndex((e) => e.item_id === status.data.item_id);
            if (index > -1 && pod[index].status !== 'FAIL') {
              //adjust transaction if failed

              const indexFinal = separateItem.findIndex((e) => e.item_id === status.data.item_id);
              console.log(indexFinal);
              if (indexFinal > -1) {
                FinalTax = parseFloat((FinalTax - separateItem[indexFinal].tax_amount).toFixed(2));
                TotalPrice = parseFloat(
                  (TotalPrice - separateItem[indexFinal].total_amount).toFixed(2)
                );
                // setFinalTax(newTax);
                // setTotalPrice(...newPrice);
                separateItem[indexFinal].err = true;
                setFinalTax(FinalTax);
                setTotalPrice(TotalPrice);
              }
              pod[index].status = 'FAIL';
              setPods([...pod]);
              countRef.current = countRef.current + 1;
            }
            setDoor(t('Your items are vending, please wait.'));
          } else if (status.data.status === 'CHANGE') {
            setDoor(t('Please collect change'));
          } else if (status.data.status === 'COMPLETED') {
            logger(2, 'Complete status received');
            await clearInterval(interval);
            setCredit(status.data.credit);
            await setTimeout(
              () => {
                setGo(true);
              },
              receiptSend ? 1000 : 5000
            );
          } else if (status.data.status === 'TAKE') {
            console.log('take');
            setDoor(t('Please grab your product'));
          }
        });
      } catch (e) {
        logger(0, 'Error when checking = ' + JSON.stringify(e));
      }
    }
  }, []);

  const deActiveOneTime = () => {
    const oneTime = JSON.parse(localStorage.getItem('oneTime'));
    if (oneTime) {
      request({
        method: 'post',
        url: oneTimeStatus,
        data: {
          promo: oneTime._id,
          input: oneTime.input,
        },
        timeout: 5000,
      }).then(() => {});
    }
  };

  const sendOrder = async () => {
    const mycoockie = Cookies.get('i18next') ? Cookies.get('i18next') : 'en';

    logger(2, 'Send Order Start');
    if (go) {
      if (separateItem?.length > 0) {
        let status = failOne ? 'Failed' : 'Completed';
        if (msc) {
          const resID = localStorage.getItem('MSC_RES');
          const mycart = separateItem.map((e) => {
            return {
              name: e.product_name,
              comment: '',
              consumer: resID,
              externalCode: e.upc,
              quantity: e.quantity,
              returnItem: false,
              voidItem: false,
            };
          });
          const result = await MscCart(mycart);
          if (result) {
            for (let i = 0; i < separateItem.length; i++) {
              separateItem[i].soldPrice = result.cart[i].total;
              separateItem[i].discount = result.cart[i].checkTotal - result.cart[i].total;
            }
            logger(1, 'Send Transaction To MSC Succeed');
          } else {
            logger(1, 'Send Transaction To MSC Failed');
            status = 'SEND TRANS TO MSC FAILED';
          }
        }

        //add banner convertion
        console.log('linkPromo', linkPromo);
        if (linkPromo?.id !== '') {
          const conIdx = separateItem.findIndex((e) => e.product === linkPromo?.id);
          if (conIdx > -1) {
            console.log('same');
            stat.banner.conv = 1;
            setStat(stat);
            console.log('stat', stat);
          }
        }
        // add prod conver
        separateItem.forEach((item) => {
          const prodIdx = stat.prod.findIndex((e) => e._id === item.product);
          if (prodIdx > -1) {
            stat.prod[prodIdx].conv += 1;
          }
        });

        let realTime = new Date();
        let date = new Date();
        const offset = date.getTimezoneOffset();
        date.setTime(date.getTime() - offset * 60 * 1000);
        //add oneTimeCode to transcation
        const oneTime = JSON.parse(localStorage.getItem('oneTime'));
        deActiveOneTime();

        stat.session_com = 1;
        setStat(stat);

        const orderData = {
          machine: machineID,
          products: separateItem,
          machineName: name,
          tax: FinalTax,
          belongTo: belongTo,
          total: TotalPrice,
          currency: currency,
          createdAt: date,
          realTime: realTime,
          otc: oneTime?.input,
          status: status,
          credit: credit,
          email: receiptSend ? input : '',
          id: name + new Date().getTime(),
          payment_type: localStorage.getItem('payment_type'),
          lang: mycoockie,
          send_order_third: localStorage.getItem('send_order_third'),
        };

        request({
          method: 'post',
          url: createOrderURL,
          data: orderData,
        })
          .then((res) => {
            setOrderID(res.data.order._id);
            setReadySend(true);
          })
          .catch((e) => {
            localRequest({
              method: 'post',
              url: createOrderURL,
              data: orderData,
            })
              .then((res) => {
                logger(2, 'Send Order Complete');
                setOrderID(res.data?.order?._id);
                setReadySend(true);
              })
              .catch((e) => {
                logger(2, 'Send Order FAILED = ' + JSON.stringify(e));
              });
          });
      }
      history.push(`/machineUI/slider/${machineID}`);
    }
  };

  useEffect(async () => {
    logger(2, 'Go trigged ' + show + ' ');
    if (go) {
      // const linkToURL = `/machineUI/home/${machineID}/`;
      if (!testMode) {
        await setTimeout(async () => {
          if (!show) {
            sendOrder();
          }
        }, 3000);
      } else {
        // history.push(linkToURL + 'true');
      }
    }
  }, [go, receiptSend, show]);

  // const updateStatus = async () => {
  //   await localRequest({
  //     method: 'post',
  //     url: `${process.env.REACT_APP_LOCAL_API}/updateKioskStatus`,
  //     data: { status: 'Active' },
  //   });
  // };

  return (
    <div className="">
      <IdleEmail go={go} sendOrder={sendOrder} />
      {/* <div className="category-container" onClick={()=>history.push(`/machineUI/product-collectioning/${machineID}`)}> */}
      <motion.div
        key="product-div"
        className="container"
        initial="initial"
        exit="out"
        animate="in"
        variants={pageVariants}
        transition={pageTransition}
        style={{ height: '1920px' }}
      >
        <div>
          <div
            style={{
              marginBottom: '50px',
            }}
            className="row justify-content-center"
          >
            <span
              style={{
                fontSize: '80px',
                marginTop: '110px',
                width: '95%',
              }}
              className="cat-title"
            >
              {door}
            </span>
          </div>
          <div className="d-flex align-items-center flex-column">
            {pod.map((e, i) => {
              if (e.item_id !== 0) {
                return (
                  <div
                    className="cart-item-style d-flex align-items-center"
                    key={i}
                    style={
                      pod.length > 3
                        ? { height: '200px', width: '470px' }
                        : { height: '230px', width: '500px' }
                    }
                  >
                    <div
                      className="col-5"
                      style={{
                        height: '80%',
                        width: '310px',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        backgroundColor: 'white',
                        border: '1em solid white',
                        borderRadius: '15px',
                        marginLeft: '30px',
                        boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2)',
                      }}
                    >
                      <img
                        style={{ maxWidth: '90%', maxHeight: '90%' }}
                        src={
                          isLocal
                            ? `${process.env.REACT_APP_LOCAL_API}/pictures/products/${e.picture}`
                            : `${process.env.REACT_APP_SERVER_API}/pictures/${e.picture}/${e.referTo}`
                        }
                        alt="Product's image"
                      />
                    </div>
                    <div
                      className="col-7"
                      style={{
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                      }}
                    >
                      <img
                        height="60%"
                        src={
                          e.status
                            ? e.status === 'SUCCESS'
                              ? completed_green
                              : e.status === 'FAIL'
                              ? completed_error
                              : completed_grey
                            : completed_grey
                        }
                        alt="dispensing_status"
                      />
                    </div>
                  </div>
                );
              }
            })}
          </div>
        </div>
        {failOne && (
          <div style={{ width: '80%', margin: 'auto', marginTop: '20px' }}>
            <span
              style={{
                fontSize: '40px',
              }}
              className="cat-title"
            >
              {t(`Sorry, Vend Error! You will not be charged for products not vended.`)}
            </span>
          </div>
        )}

        <EnterEmail
          receipt={receipt}
          input={input}
          setInput={setInput}
          id={machineID}
          machine={props.machine}
          orderID={orderID}
          testMode={props.testMode}
          receiptSend={receiptSend}
          readySend={readySend}
          separateItem={separateItem}
          setReceiptSend={setReceiptSend}
          show={show}
          setShow={setShow}
        />
      </motion.div>
    </div>
  );
}
